import { Helmet } from "react-helmet-async";

export default function MentionsLegalesPage() {
  return (
    <>
      <Helmet><title>Mentions légales - OFALycée</title></Helmet>
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="mentions-legales-page">
        <h1 className="font-heading text-3xl md:text-4xl mb-10">Mentions légales</h1>

        <div className="prose max-w-none">
          <h2>Éditeur du site</h2>
          <p>
            Le site <strong>OFALycée</strong> est édité par :<br />
            <strong>OFALYCEE, Inc.</strong><br />
            Siège social : Winchester, Massachusetts, États-Unis<br />
            Directrice de la publication : <strong>Géraldine Guillermin</strong><br />
            Contact : <a href="mailto:contact@ofalycee.org">contact@ofalycee.org</a>
          </p>

          <h2>Hébergement</h2>
          <p>
            Le site est hébergé par :<br />
            <strong>Emergent Agent</strong><br />
            Infrastructure cloud (Kubernetes)<br />
            Site : <a href="https://www.emergentagent.com" target="_blank" rel="noopener noreferrer">www.emergentagent.com</a>
          </p>

          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus présents sur ce site (textes, articles, photographies, illustrations, logos, vidéos)
            sont la propriété exclusive d'OFALYCEE, Inc. ou de leurs auteurs respectifs, et sont protégés par le droit
            d'auteur et le droit de la propriété intellectuelle.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments
            du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable
            d'OFALYCEE, Inc.
          </p>

          <h2>Responsabilité</h2>
          <p>
            OFALYCEE, Inc. s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois,
            elle ne pourra être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour,
            qu'elles soient de son fait ou du fait de tiers partenaires qui lui fournissent ces informations.
          </p>
          <p>
            Les liens hypertextes mis en place dans le cadre du présent site en direction d'autres ressources
            sur Internet ne sauraient engager la responsabilité d'OFALYCEE, Inc.
          </p>

          <h2>Données personnelles</h2>
          <p>
            Pour toute information relative au traitement de vos données personnelles, veuillez consulter
            notre <a href="/politique-de-confidentialite">Politique de confidentialité</a>.
          </p>

          <h2>Droit applicable</h2>
          <p>
            Le présent site et les présentes mentions légales sont régis par le droit des États-Unis
            d'Amérique et de l'État du Massachusetts. Tout litige sera soumis à la compétence exclusive
            des tribunaux de l'État du Massachusetts.
          </p>
        </div>
      </div>
    </>
  );
}
